<form class="new-report-form" [formGroup]="form" *ngIf="!isLoading else loadingAnimation">
    <app-scroll-list-item
        title="{{'admin.strain.tickets.reports.modal.step1.newReport'| translate}}"
        leftIcon="fa-file"
        [selected]="control('isNewReport').value"
        (select)="onSelectNewReport(true)">
    </app-scroll-list-item>

    <app-scroll-list-item
        title="{{'admin.strain.tickets.reports.modal.step1.fromAnother'| translate}}"
        leftIcon="fa-files-o"
        [selected]="!control('isNewReport').value"
        (select)="onSelectNewReport(false)">
    </app-scroll-list-item>

    <app-dropdown-autocomplete
        class="reports"
        *ngIf="!control('isNewReport').value"
        valueField="id"
        displayField="name"
        emptyText="{{'admin.strain.tickets.reports.modal.step1.report' | translate}}"
        [formControl]="control('templateReport')"
        [items]="similarMeasurements"
        [showErrors]="showValidations || control('templateReport').touched && control('templateReport').invalid">
    </app-dropdown-autocomplete>
</form>
<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
